/**
 * Build a NPI-style primary_address object from a facility-validate API row
 * (parent / main / sibling / suggestion). Preserves civic lines the API returns;
 * only falls back to city+state when no street or postal context exists.
 */
export function primaryAddressFromFacilityValidationRow(
  row: Record<string, unknown>,
  stateFallback?: string,
): Record<string, string | undefined> | undefined {
  const pa = row.primary_address;
  if (pa && typeof pa === "object" && !Array.isArray(pa)) {
    return pa as Record<string, string | undefined>;
  }

  const flatA1 = String(row.address_1 ?? "").trim();
  const flatFull = String(row.full_address ?? "").trim();
  const postal = String(row.postal_code ?? "").trim();
  const city = String(row.city ?? "").trim();
  const state = String(row.state ?? stateFallback ?? "").trim();

  if (flatA1 || flatFull || postal) {
    const line1 = flatA1 || flatFull || undefined;
    return {
      address_1: line1,
      address_2: String(row.address_2 ?? "").trim() || undefined,
      city: city || undefined,
      state: state || undefined,
      postal_code: postal || undefined,
      country_code:
        String(row.country_code ?? row.country ?? "").trim() || undefined,
    };
  }

  if (city || state) {
    return { city: city || undefined, state: state || undefined };
  }

  return undefined;
}
